<template>
  <BaseVeeForm :action="joinConversation" v-slot="{ isPending }" class="space-y-2">
    <ValidationProvider name="conversation" tag="div" vid="conversation">
      <template #default="{ errors, failed }">
        <BaseFormInput type="hidden" v-model="conversationId" />
        <BaseFormInlineMessage v-if="failed" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>
    <BaseButton primary class="w-full" :disabled="isPending"> Join Conversation </BaseButton>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    conversation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      conversationId: this.conversation.id,
    };
  },
  methods: {
    async joinConversation() {
      try {
        await this.$store.dispatch('ui/joinedConversations/store', {
          conversationId: this.conversationId,
        });
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
